import { create } from "zustand";
import { persist } from "zustand/middleware";
import container from "@src/container";

const { dateSettingsCache } = container;
const dateSettings = dateSettingsCache.get();

const persistData = (data) => {
  const cache = dateSettingsCache.get();
  dateSettingsCache.set({ ...cache, ...data });
};

export const useDateStore = create(
  persist(
    (set) => ({
      lastDateRange: dateSettings?.lastDateRange,
      lastDateFilter: dateSettings?.lastDateFilter,
      setLastDateRange: (value) => {
        set((state) => {
          if (state.lastDateRange !== value) {
            persistData({ lastDateRange: value, lastDateFilter: undefined });
            return { lastDateRange: value, lastDateFilter: undefined };
          }
          return state;
        });
      },
      setLastDateFilter: (value) => {
        set((state) => {
          if (state.lastDateFilter !== value) {
            persistData({ lastDateFilter: value, lastDateRange: undefined });
            return { lastDateFilter: value, lastDateRange: undefined };
          }
          return state;
        });
      },
    }),
    {
      name: "date-store",
      partialize: (state) => ({
        lastDateRange: state.lastDateRange,
        lastDateFilter: state.lastDateFilter,
      }),
    }
  )
);
